import tw, { styled } from 'twin.macro';
import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media ${MEDIA_QUERIES.tablet} {
    width: fit-content;
    width: -moz-fit-content;
  }
  .head-box {
    width: 100%;
  }
  .share-box {
    width: 100%;
    display: flex;
    align-items: center;
    .share-container {
      display: flex;
    }
    .share-article-container {
      padding: 16px 0 0 0;
      @media ${MEDIA_QUERIES.tablet} {
        padding: 0;
      }
    }
  }
  .header-subname {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 0 0 10px 0;
    @media ${MEDIA_QUERIES.tablet} {
      margin: 0;
    }
  }
`;

export const HeaderImage = styled.div`
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    @media ${MEDIA_QUERIES.tablet} {
      width: 250px;
      height: 250px;
    }
  }
  &.mobile {
    @media ${MEDIA_QUERIES.tablet} {
      display: none;
    }
  }
  &.desktop {
    display: none;
    @media ${MEDIA_QUERIES.tablet} {
      display: flex;
    }
  }
`;

export const DataContent = styled.div`
  width: 100%;
  .data-container {
    gap: 0;
  }
  .divider {
    margin: 24px 0;
  }
`;

export const DataContainerHead = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 0 24px 0;
  @media ${MEDIA_QUERIES.tablet} {
    margin: 0 0 50px 0;
  }
`;

export const DataContainerTitle = styled.div`
  width: 100%;
  border-bottom: 2px solid #000000;
  padding: 0 0 24px 0;
  @media ${MEDIA_QUERIES.tablet} {
    padding: 0;
  }
  .head {
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
    font-family: 'Poppins';
    @media ${MEDIA_QUERIES.tablet} {
      font-size: 32px;
    }
  }
`;

export const AuthorMedia = styled.a`
  height: 40px;
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-top: 16px;
  @media ${MEDIA_QUERIES.tablet} {
    margin-top: 0;
  }
`;
